import { useState } from "react";
import { RefreshCw } from "lucide-react";
import { Card, Btn, Badge, useData } from "./ui";
import { BuyerLink } from "./SaleExtras";

const fmt = (s) => (s ? new Date(s).toLocaleString("nb-NO", { dateStyle: "short", timeStyle: "short" }) : "–");

const Row = ({ p, reload }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="py-3" data-testid={`pending-sig-${p.id}`}>
      <div className="flex flex-wrap items-start justify-between gap-2">
        <div className="text-sm">
          <div><span className="font-bold">{p.buyer_name || "Kjøper uten navn"}</span> <span className="text-zinc-400">{p.buyer_email || "ingen e-post"}</span></div>
          <div className="text-xs text-zinc-400"><span className="font-mono text-zinc-200">{p.number}</span> · {p.title}{p.version > 1 ? ` (versjon ${p.version})` : ""} · {p.vehicle}</div>
          <div className="mt-1 flex flex-wrap gap-2">
            <Badge tone={p.link_active ? "sky" : "amber"}>{p.link_active ? `Lenke aktiv til ${fmt(p.link_expires_at)}` : p.link_created_at ? "Lenken er utløpt" : "Ingen lenke sendt"}</Badge>
            {!p.seller_signed && <Badge tone="red">Selger har ikke signert</Badge>}
            {p.last_email_at && <span className="text-xs text-zinc-400">Sist sendt {fmt(p.last_email_at)}</span>}
          </div>
        </div>
        <Btn onClick={() => setOpen(!open)} data-testid={`pending-sig-resend-${p.id}`}><RefreshCw size={14} /> Send lenke på nytt</Btn>
      </div>
      {open && <BuyerLink doc={p} buyerEmail={p.buyer_email} onDone={reload} />}
    </div>
  );
};

export const PendingSignatures = () => {
  const [list, reload] = useData("/admin/signatures/pending");
  const items = Array.isArray(list) ? list : [];
  return (
    <Card data-testid="pending-signatures">
      <h3 className="font-display text-xl font-bold uppercase">Venter på kjøpers signatur ({items.length})</h3>
      <p className="mb-2 text-xs text-zinc-400">Kun siste versjon av hvert dokument vises. En ny lenke gjør tidligere lenker ugyldige.</p>
      {items.length === 0 ? <p className="text-sm text-zinc-400" data-testid="pending-signatures-empty">Alle kjøpere har signert.</p>
        : <div className="divide-y divide-white/10">{items.map((p) => <Row key={p.id} p={p} reload={reload} />)}</div>}
    </Card>
  );
};
